import React from 'react';

import LinkIcon from 'assets/svg/link.svg';
import FeedbackIcon from 'assets/svg/feedback-new.svg';
import MenuDotsIcon from 'assets/svg/menu-dots.svg';

import { getDirection, isServer } from 'utils';
import { useInsightExpandUrlCreator } from 'hooks/useInsightExpandUrlCreator';

import {
  MenuDotsWrapper,
  DropdownWrapper,
} from './styled';
import { ExpandCollection } from 'store/state/insightsContext';
import { useLocale } from 'locale';
import Select from 'ds/components/input/Select';
import { ShowAt } from 'consts/breakpoints';
import { useTheme } from 'hooks/useTheme';
import { CopyText } from 'ds/components/copy-text';


interface DropdownProps {
  openFeedbackPopup: () => void;
  insightId: string;
  expandCollection: ExpandCollection;
}

enum InsightOptionValue {
  Link = 'copyLink',
  SendFeedback = 'sendFeedback',
}

const shouldStayOpen = (value: string) => {
  return value === InsightOptionValue.Link;
};

const insightOptions = [
  {
    label: InsightOptionValue.Link,
    value: InsightOptionValue.Link,
    icon: <LinkIcon width={16} height={16} />,
  },
  {
    label: InsightOptionValue.SendFeedback,
    value: InsightOptionValue.SendFeedback,
    icon: <FeedbackIcon width={24} height={24} />,
  },
];

const Dropdown: React.FC<DropdownProps> = (props) => {
  const { insightId, openFeedbackPopup, expandCollection } = props;
  const { t } = useLocale();
  const { isRTL } = useTheme();

  const urlBuilder = useInsightExpandUrlCreator(expandCollection);
  const url = `${(isServer() ? null : window.location.origin)}${urlBuilder(insightId)}`;

  const shouldResetSelectedValue = () => true;

  const onChange = (vendor: string) => {
    if (vendor === InsightOptionValue.SendFeedback) {
      openFeedbackPopup();
    }
  };

  const stopEventPropagation = (e: React.SyntheticEvent) => e.stopPropagation();

  const options = insightOptions.map(({ label, value, icon }) => ({
    value,
    icon,
    label: t('select.share.label', { label }),
  }));


  return (
    <div onClick={stopEventPropagation}>
      <ShowAt to={2}>
        {isMobile => (
          <Select
            isUncontrolled
            items={options}
            onChange={onChange}
            shouldStayOpen={shouldStayOpen}
            selectionPromptText={t('unitPage.share.title')}
            shouldResetSelectedValue={shouldResetSelectedValue}
            alignment={getDirection(isRTL, !isMobile)}
            renderItem={(item, isSelected) => item.value === InsightOptionValue.Link ? (
              <CopyText item={item} copyText={url} isSelected={isSelected} />
            ) : (
              Select.defaultProps.renderItem(item, isSelected)
            )}
            renderCustomToggle={toggleProps => (
              <DropdownWrapper>
                <MenuDotsWrapper data-auto="menu-dots-button" className="menu-dots-icon" {...toggleProps}>
                  <MenuDotsIcon />
                </MenuDotsWrapper>
              </DropdownWrapper>
            )}
          />
        )}
      </ShowAt>
    </div>
  );
};

export default Dropdown;
